import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeleteDraftTemplateModalConfirm } from '../../modal';

@Component({
  selector: 'libero-template-draft-delete-modal',
  templateUrl: './template-draft-delete-modal.component.html',
  styleUrl: './template-draft-delete-modal.component.scss',
  standalone: false
})
export class TemplateDraftDeleteModalComponent {
  @Input() public templateDraft: DeleteDraftTemplateModalConfirm | null = null;
  @Output() public continueBtnClick = new EventEmitter<void>();
  @Output() public backBtnClick = new EventEmitter<void>();

  public onContinueBtnClick(): void {
    this.continueBtnClick.emit();
  }

  public onBackBtnClick(): void {
    this.backBtnClick.emit();
  }
}
